import { Plate, TEditableProps } from '@udecode/plate';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getRandomNumber } from '~/utils/numbers';
import { EditorErrorBoundary } from '../components/EditorErrorBoundary';
import { BufferEditor, BufferValue } from '../BufferEditor/types.plate';
import {
  EmojiCombobox,
  EmojiPicker,
  EmojiPickerIcon,
  EmojiPickerIconCircle,
} from '../plugins/emoji';
import { IdeasEmojiPickerIconContainer } from './styles';

export const IdeasEditor = ({
  editor,
  onChange,
}: {
  editor: BufferEditor;
  onChange: (value) => void;
}): JSX.Element => {
  const { t } = useTranslation();

  const editableProps: TEditableProps<BufferValue> = useMemo(
    () => ({
      spellCheck: false,
      autoFocus: true,
      readOnly: false,
      placeholder: t(`content.editor.placeholder.${getRandomNumber(14)}`),
      style: { height: '100%' },
    }),
    [t]
  );

  return (
    <EditorErrorBoundary editor={editor}>
      <Plate<BufferValue>
        editor={editor}
        onChange={onChange}
        editableProps={editableProps}
      >
        <EmojiCombobox maxSuggestions={8} />
        <EmojiPicker editor={editor}>
          <IdeasEmojiPickerIconContainer>
            <EmojiPickerIconCircle>
              <EmojiPickerIcon />
            </EmojiPickerIconCircle>
          </IdeasEmojiPickerIconContainer>
        </EmojiPicker>
      </Plate>
    </EditorErrorBoundary>
  );
};
